var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnopened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 0.158691H2.67969C2.10547 0.158691 1.61328 0.541504 1.44922 1.06104L0.0546875 5.21729C0.0273438 5.27197 0.0273438 5.354 0.0273438 5.40869H6.5625V0.158691ZM12.9883 2.40088L12.5234 1.06104C12.3594 0.541504 11.8672 0.158691 11.293 0.158691H7.4375V4.479C8.61328 3.1665 10.3359 2.34619 12.25 2.34619C12.4961 2.34619 12.7422 2.37354 12.9883 2.40088ZM5.6875 8.90869C5.6875 7.979 5.87891 7.104 6.23438 6.28369H0V12.8462C0 13.5845 0.574219 14.1587 1.3125 14.1587H8.3125C6.72656 12.9829 5.6875 11.0688 5.6875 8.90869ZM12.25 3.65869C9.35156 3.65869 7 6.01025 7 8.90869C7 11.8071 9.35156 14.1587 12.25 14.1587C15.1484 14.1587 17.5 11.8071 17.5 8.90869C17.5 6.01025 15.1484 3.65869 12.25 3.65869ZM15.3672 7.70557L11.7852 11.2603C11.6484 11.397 11.457 11.397 11.3477 11.2603L9.26953 9.18213C9.16016 9.07275 9.16016 8.88135 9.26953 8.74463L9.98047 8.03369C10.1172 7.92432 10.3086 7.92432 10.418 8.06104L11.5664 9.20947L14.2188 6.58447C14.3555 6.44775 14.5469 6.44775 14.6562 6.58447L15.3672 7.29541C15.4766 7.40479 15.4766 7.59619 15.3672 7.70557Z",
    fill: "#A21D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnopened);
export default __webpack_public_path__ + "static/media/unopened.5d3307bfdfd0ffbf0992cb2e6e845fee.svg";
export { ForwardRef as ReactComponent };